import { render } from "./OtiActionsSmallAdmin.vue?vue&type=template&id=6af19729&scoped=true"
import script from "./OtiActionsSmallAdmin.vue?vue&type=script&lang=js"
export * from "./OtiActionsSmallAdmin.vue?vue&type=script&lang=js"

import "./OtiActionsSmallAdmin.vue?vue&type=style&index=0&id=6af19729&lang=scss&scoped=true"

import exportComponent from "E:\\laragon\\www\\proyectos\\laravel\\sandy_laravel_vue\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af19729"]])

export default __exports__